import React, { useEffect, useRef } from 'react'

import "./Recruitment.css"

import { ReactComponent as Clock } from '../assets/icons/clock.svg'
import { ReactComponent as Group } from '../assets/icons/group.svg'
import { ReactComponent as Box } from '../assets/icons/box.svg'

import { ReactComponent as Solution } from '../assets/icons/solution.svg'
import Professions from './Professions'

import { useTranslate } from "../Context/LanguageContext"
import Button from '../Util/Button'

const Recruitment = () => {

    const t = useTranslate("recruitment")

    const stepsRef = useRef(null)

    // Treibt das "Andocken" der Steps an. Bewusst ohne CSS-calc()/var() und ohne
    // Viewport-Annahmen, damit es auch in Safari/iOS sicher läuft:
    //  - Andock-Ziel ist die GEMESSENE Position des lila Counter-Kreises (nicht
    //    window.innerHeight/2). So passt es trotz vh/dvh/URL-Bar-Unterschieden.
    //  - scale()/opacity werden als fertige Inline-Styles gesetzt (kein calc(var())),
    //    was in WebKit teils nicht zuverlässig funktioniert.
    useEffect(() => {
        const container = stepsRef.current
        if (!container) return

        const items = Array.from(container.querySelectorAll('.step')).map((step) => ({
            step,
            num: step.querySelector('.num'),
            texts: step.querySelectorAll('h3, p'),
        }))
        if (items.length === 0) return

        const circle = document.querySelector('.recruitment .counter .circle')

        let ticking = false

        const update = () => {
            ticking = false

            // Andock-Ziel = gemessene Mitte des lila Kreises. Auf Mobil ist der Kreis
            // ausgeblendet (height 0) -> dann die sichtbare Viewport-Mitte verwenden.
            const circleRect = circle ? circle.getBoundingClientRect() : null
            const targetY = circleRect && circleRect.height
                ? circleRect.top + circleRect.height / 2
                : window.innerHeight / 2
            // Strecke, über die ein Step von "ruhend" zu "voll angedockt" übergeht
            const range = window.innerHeight * 0.28

            for (const { step, num, texts } of items) {
                const rect = step.getBoundingClientRect()
                const stepCenter = rect.top + rect.height / 2
                const distance = Math.abs(stepCenter - targetY)
                const p = Math.max(0, Math.min(1, 1 - distance / range))

                if (num) {
                    num.style.transform = `translate(-50%, -50%) scale(${(1 + 0.5 * p).toFixed(4)})`
                }
                const opacity = (0.2 + 0.8 * p).toFixed(4)
                for (const text of texts) {
                    text.style.opacity = opacity
                }
            }
        }

        const onScroll = () => {
            if (!ticking) {
                ticking = true
                window.requestAnimationFrame(update)
            }
        }

        update()
        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', onScroll)

        return () => {
            window.removeEventListener('scroll', onScroll)
            window.removeEventListener('resize', onScroll)
        }
    }, [])

    return (
        <div className='recruitment'>
            <div id='image'>
                <img
                    src='./images/recruitement.webp'
                    alt=""
                    loading='eager'
                    decoding='async'
                />
                <span className='overlay' aria-hidden='true' />
            </div>

            <section className='heading'>
                <div className='wrapper'>
                    <h1>
                        {t("heading1")} <br />
                        <span>{t("heading2")} <br /> {t("heading3")}</span> <br />
                        {t("heading4")}
                    </h1>
                </div>
            </section>

            <section className='intro'>
                <div className='container'>

                    <p className='text'>{t("text")}</p>

                    <div className='wrapper'>
                        <div className='advantage'>
                            <Clock aria-hidden='true' />
                            <h3>{t("time1")}</h3>
                            <p>{t("time2")}</p>
                        </div>

                        <div className='advantage'>
                            <Group aria-hidden='true' />
                            <h3>{t("sustainable1")}</h3>
                            <p>{t("sustainable2")}</p>
                        </div>

                        <div className='advantage'>
                            <Box aria-hidden='true' />
                            <h3>{t("package1")}</h3>
                            <p>{t("package2")}</p>
                        </div>
                    </div>

                    <Button to="/contact" filled>{t("contact")}</Button>

                </div>
            </section>

            <section className='steps'>
                <div className='left'>
                    <div className='wrapper'>
                        <div>
                            <Solution aria-hidden='true' />
                        </div>
                        <p>{t("steps1")} <br /> in <span>5</span> {t("steps2")}</p>
                    </div>
                </div>

                <div className='counter' aria-hidden='true'>
                    <div className='line up' />
                    <div className='circle' />
                    <div className='line down' />
                </div>

                <div className='right' ref={stepsRef}>

                    <div className='step'>
                        <div className='num'>1</div>
                        <span aria-hidden='true' />
                        <h3>{t("step1")}</h3>
                        <p>{t("txt1")}</p>
                    </div>

                    <div className='overlay up' aria-hidden='true' />
                    <div className='overlay down' aria-hidden='true' />

                    <div className='step'>
                        <div className='num'>2</div>
                        <span aria-hidden='true' />
                        <h3>{t("step2")}</h3>
                        <p>{t("txt2")}</p>
                    </div>

                    <div className='step'>
                        <div className='num'>3</div>
                        <span aria-hidden='true' />
                        <h3>{t("step3")}</h3>
                        <p>{t("txt3")}</p>
                    </div>

                    <div className='step'>
                        <div className='num'>4</div>
                        <span aria-hidden='true' />
                        <h3>{t("step4")}</h3>
                        <p>{t("txt4")}</p>
                    </div>

                    <div className='step'>
                        <div className='num'>5</div>
                        <span aria-hidden='true' />
                        <h3>{t("step5")}</h3>
                        <p>{t("txt5")}</p>
                    </div>

                </div>
            </section>

            <Professions />

        </div>
    );
}

export default Recruitment;